import { Link } from 'react-router-dom'
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { saveAs } from 'file-saver'
import { pdf } from '@react-pdf/renderer'
import { call } from '../Methods.js'
import Input from '../Components/Input'
import { use } from '../Helpers'
import Report from '../ReportTemplates/Report.js'

function Reports () {
  const pageTitle = 'Hesabatlar'
  document.title = `${pageTitle} | ${process.env.REACT_APP_NAME}`
  const [activeReport, setActiveReport] = useState(null)
  const [loading, setLoading] = useState(false)
  const [reportData, setReportData] = useState(null)
  const navigate = useNavigate()
  const { report } = useParams()

  useEffect(() => {
    if (activeReport != null) {
      navigate(`/reports/${activeReport.urlTitle}`, { replace: true })
      document.body.style.overflowY = 'hidden'
    } else {
      navigate('/reports', { replace: true })
      document.body.style.overflowY = 'auto'
    }
  }, [activeReport])

  useEffect(() => {
    if (!(undefined, null, '').includes(report)) {
      reportTypes
        .map(a => a.reports)
        .flat()
        .forEach(_report => {
          if (_report.urlTitle == report) {
            setActiveReport(_report)
            return
          }
        })
    }
  }, [report])

  const reportTypes = [
    {
      reportGroupName: 'Maliyyə Hesabatları',
      reports: [
        {
          title: 'Ümumi dövriyyə',
          urlTitle: 'dövriyyə',
          enabled: true,
          template: 'CashFlowReport',
          description: 'Tarix aralıqlarına görə mədaxil və məxaric',
          methods: {
            get: parameters =>
              call.forLoggedUser.report.getCashFlowReport(parameters)
          },

          parameterFields: [
            {
              label: 'Başlanğıc',
              type: 'date',
              defaultValue: new Date(
                new Date().setMonth(new Date().getMonth() - 1)
              ).toLocaleDateString('az-AZ'),
              fieldName: 'from',
              col: { sm: 12 },
              mutate: value => {
                return new Date(value).toLocaleDateString('az-AZ')
              }
            },
            {
              label: 'Son',
              type: 'date',
              defaultValue: new Date().toLocaleDateString('az-AZ'),
              fieldName: 'to',
              col: { sm: 12 },
              mutate: value => {
                return new Date(value).toLocaleDateString('az-AZ')
              }
            }
          ]
        },
        {
          title: `Filial üzrə dövriyyə`,
          urlTitle: 'dövriyyə-filial',
          enabled: true,
          template: 'CashFlowReport',
          description: 'Filial üzrə tarix aralıqlarına görə mədaxil və məxaric',
          methods: {
            get: parameters =>
              call.forLoggedUser.report.getCashFlowReport(parameters)
          },

          parameterFields: [
            {
              label: 'Filial',
              type: 'select',
              fieldName: 'branchId',
              col: { sm: 12 },
              validationRules: ['required'],
              dataSource: async () => {
                const source = await call.forLoggedUser.branch.getBranches({
                  statusId: 1
                })
                let data = source.data.map(d => {
                  return { value: d.id, text: `${d.code} - ${d.name}` }
                })
                return data
              }
            },
            {
              label: 'Başlanğıc',
              type: 'date',
              defaultValue: new Date(
                new Date().setMonth(new Date().getMonth() - 1)
              ).toLocaleDateString('az-AZ'),
              fieldName: 'from',
              col: { sm: 12 },
              mutate: value => {
                return new Date(value).toLocaleDateString('az-AZ')
              }
            },
            {
              label: 'Son',
              type: 'date',
              defaultValue: new Date().toLocaleDateString('az-AZ'),
              fieldName: 'to',
              col: { sm: 12 },
              mutate: value => {
                return new Date(value).toLocaleDateString('az-AZ')
              }
            }
          ]
        }
      ]
    },
    {
      reportGroupName: 'Təhsil Hesabatları',
      reports: [
        {
          title: 'Tələbə tarixçəsi',
          template: 'StudentReport',
          enabled: false,
          urlTitle: 'tələbə-tarixçəsi',
          description: 'Davamiyyət, nəticələr, ödənişlər',
          methods: {
            get: parameters =>
              call.forLoggedUser.report.getIndividualStudentReport(parameters)
          },
          parameterFields: [
            {
              label: 'İştirakçı seçin',
              type: 'select',
              fieldName: 'studentId',
              defaultSelectOptions:[[{value:'',text:'Seçin...'}]],
              col: { sm: 12 },
              dataSource: async () => {
                const source = await call.forLoggedUser.student.getStudents({})
                console.log(source)
                let data = source.data.map(d => {
                  return { value: d.id, text: `${d.name} ${d.surname}` }
                })
                return data
              }
            }
          ]
        },
        {
          title: 'Qrup tarixçəsi',
          template: 'GroupReport',
          enabled: false,
          urlTitle: 'qrup-tarixçəsi',
          description: 'Davamiyyət, nəticələr, ödənişlər',
          methods: {
            get: parameters =>
              call.forLoggedUser.report.getIndividualGroupReport(parameters)
          },
          parameterFields: [
            {
              label: 'Qrup seçin',
              type: 'select',
              fieldName: 'groupId',
              col: { sm: 12 },
              dataSource: async () => {
                const source = await call.forLoggedUser.group.getGroups({})
                console.log(source)
                let data = source.data.map(d => {
                  return { value: d.id, text: `${d.name}` }
                })
                return data
              }
            }
          ]
        }
      ]
    },
    {
      reportGroupName: 'Biznes Hesabatları',
      reports: [
        {
          title: 'Satış Hesabatı',
          template: 'SalesReport',
          enabled: false,
          urlTitle: 'satış-hesabatı',
          description: 'Müraciətlər, qeydiyyat və iştirak',
          methods: {
            get: parameters =>
              call.forLoggedUser.report.getIndividualGroupReport(parameters)
          },
          parameterFields: [
            {
              label: 'Qrup seçin',
              type: 'select',
              fieldName: 'groupId',
              col: { sm: 12 },
              dataSource: async () => {
                const source = await call.forLoggedUser.group.getGroups({})
                console.log(source)
                let data = source.data.map(d => {
                  return { value: d.id, text: `${d.name}` }
                })
                return data
              }
            }
          ]
        },
        {
          title: 'Rüblük Hesabat',
          template: 'QuarterReport',
          urlTitle: 'rüblük-hesabat',
          description: 'Davamiyyət, nəticələr, ödənişlər',
          enabled: false,
          methods: {
            get: parameters =>
              call.forLoggedUser.report.getIndividualGroupReport(parameters)
          },
          parameterFields: [
            {
              label: 'Qrup seçin',
              type: 'select',
              fieldName: 'groupId',
              col: { sm: 12 },
              dataSource: async () => {
                const source = await call.forLoggedUser.group.getGroups({})
                console.log(source)
                let data = source.data.map(d => {
                  return { value: d.id, text: `${d.name}` }
                })
                return data
              }
            }
          ]
        }
      ]
    }
  ]

  const submitForm = async e => {
    setLoading(true)
    e.preventDefault()
    const data = collectFormData(activeReport.title)
    const result = await activeReport.methods.get(data)
    if (result.success) {
      setReportData(result.data)
      const fileName = `${activeReport.title}.pdf`
      const blob = await pdf(
        <Report
          reportTemplate={activeReport.template}
          reportData={result.data}
        /> //reportTemplate={activeReport.template} reportParameters={parameters}
      ).toBlob()
      saveAs(blob, fileName)
      setTimeout(() => {
        setLoading(false)
      }, 1000)
    } else {
      setLoading(false)
      alert('Xəta baş verdi')
    }
  }

  const collectFormData = () => {
    let data = {}
    activeReport.parameterFields.forEach(f => {
      if (
        f.type != 'readonly-text' &&
        f.fieldName != undefined &&
        !f.disabled
      ) {
        data[f.fieldName] = use.getInputValueByName(f.fieldName)
      }
    })
    return data
  }

  const renderReportParameterFields = () => {
    if (activeReport)
      return (
        <>
          <form
            className='report-form row'
            name={activeReport.title}
            onSubmit={e => submitForm(e)}
          >
            {activeReport.parameterFields.map((field, index) => {
              return (
                <Input
                  key={`${field.fieldName}#${index}`}
                  fieldName={field.fieldName}
                  disabled={field.disabled || loading}
                  label={field.label}
                  placeholder={field.placeholder}
                  type={field.type}
                  defaultSelectOptions={field.defaultSelectOptions}
                  col={field.col}
                  acceptNullValue={field.acceptNullValue}
                  data={field.dataSource ? null : field.data}
                  dataSource={field.dataSource}
                  value={field.defaultValue}
                  eventHandler={field.eventHandlers}
                />
              )
            })}
            <Input
              label={`${loading ? 'Hazırlanır...' : 'Yükləyin'}`}
              type='submit'
              disabled={loading}
              style={{ margin: '15px 0px 10px', padding: '7px 0' }}
            />
          </form>
        </>
      )
  }

  return (
    <div className='page reports-page'>
      <h1 className='page-title'>Hesabatlar</h1>
      {reportTypes.map((reportType,index) => {
        return (
          <div key={reportType.reportGroupName + index} className='reports-section page-section'>
            <h2 className='section-header'>{reportType.reportGroupName}</h2>
            <div className='reports'>
              {reportType.reports.map(report => {
                return (
                  <ReportItem
                    key={report.title}
                    title={report.title}
                    urlTitle={report.urlTitle}
                    description={report.description}
                    enabled={report.enabled}
                  />
                )
              })}
            </div>
          </div>
        )
      })}
      {activeReport && (
        <div className={`report-modal-container ${activeReport ? 'open' : ''}`}>
          <div className='report-modal'>
            <div className='header'>
              <h3 className='heading'>{activeReport?.title}</h3>
              <span className='close' onClick={() => setActiveReport(null)}>
                &times;
              </span>
            </div>
            {activeReport && renderReportParameterFields()}
          </div>
        </div>
      )}
    </div>
  )
}

function ReportItem ({ title, urlTitle, description, enabled }) {
  return (
    <Link
      className={`report${enabled ? '' : ' disabled'}`}
      to={enabled ? `/reports/${urlTitle}` : ''}
    >
      <span className='report-icon'>
        <img src='/Images/Icons/menu-icons/report.svg' />
      </span>
      <span className='report-title'>{title}</span>
      <span className='report-description'>{description}</span>
    </Link>
  )
}

export default Reports
